import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import * as firebase from "firebase/app";
import "firebase/auth";
import { initFirebase } from "@/utils/firebase";
import i18n from "./i18n";
import "mustard-ui/dist/css/mustard-ui.min.css"; //Vuesax styles

Vue.config.productionTip = false;

const init = async () => {
  // Wait for all the async pieces needed before initializing Vue
  await Promise.all([initFirebase()]);

  /* eslint-disable no-new */
  new Vue({
    el: "#app",
    store,
    router,
    i18n,
    render: (h) => h(App),
  });

  // Disable middle mouse button scroll
  document.getElementById("app").onmousedown = function(e) {
    if (e.button === 1) return false;
  };

  firebase.auth().onAuthStateChanged(async (user) => {
    if (user) {
      await Promise.all([
        store.dispatch("userData/loggedInAction", true),
        store.dispatch("userData/userAction", user),
        store.dispatch("userData/userDataAction", {
          name: user.displayName,
          email: user.email,
          emailVerified: user.emailVerified,
          photo: user.photoURL,
        }),
        store.dispatch("userData/isAnonymousAction", user.isAnonymous),
      ]);
    } else {
      store.dispatch("userData/loggedInAction", false);
      store.dispatch("userData/userAction", {});
      store.dispatch("userData/userDataAction", {});
      store.dispatch("userData/isAnonymousAction", false);
    }

    store.commit("userData/authSettledMutation", true);
  });
};

init();
